import { Link } from 'react-router-dom';

export default function HomeCTA() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="relative overflow-hidden bg-gradient-to-br from-teal-600 to-teal-500 rounded-3xl p-14 text-center">
          {/* Background pattern */}
          <div className="absolute inset-0 opacity-10">
            <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <pattern id="cta-dots" x="0" y="0" width="30" height="30" patternUnits="userSpaceOnUse">
                  <circle cx="2" cy="2" r="1.5" fill="white" />
                </pattern>
              </defs>
              <rect width="100%" height="100%" fill="url(#cta-dots)" />
            </svg>
          </div>
          <div className="relative z-10">
            <div className="inline-flex items-center gap-2 bg-white/20 text-white text-xs font-semibold px-4 py-2 rounded-full mb-6">
              <span className="w-2 h-2 bg-white rounded-full animate-pulse" />
              25 Years of IT Excellence
            </div>
            <h2 className="text-4xl lg:text-5xl font-extrabold text-white mb-5 max-w-3xl mx-auto leading-tight">
              Ready to Transform Your Business with Technology?
            </h2>
            <p className="text-teal-100 text-lg mb-10 max-w-2xl mx-auto">
              Get a free consultation with our team of certified IT experts. ISO 9001:2015 &amp; ISO/IEC 27001:2022 certified — quality and security guaranteed.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <Link
                to="/contact"
                className="cursor-pointer whitespace-nowrap bg-white hover:bg-gray-50 text-teal-700 font-semibold px-8 py-4 rounded-xl transition-colors inline-flex items-center gap-2"
              >
                <i className="ri-calendar-check-line" />
                Get Free Consultation
              </Link>
              <Link
                to="/portfolio"
                className="cursor-pointer whitespace-nowrap border border-white/40 text-white hover:bg-white/10 font-semibold px-8 py-4 rounded-xl transition-colors inline-flex items-center gap-2"
              >
                <i className="ri-folder-line" />
                View Our Portfolio
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
